// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Pe_av","colBig":"styles_colBig__2mgwH","colSmall":"styles_colSmall__1jrHi"};